'use strict';

(function (root, factory) {
  if (typeof exports === "object") {
    // Node, CommonJS
    module.exports = factory(require("cldrjs"), require("@paypalcorp/globalize"), require("make-plural"));
  } else {
    // Extend global
    factory(root.Cldr, root.Globalize);
  }
})(undefined, function (Cldr, Globalize) {
  var formatMessage = Globalize._formatMessage,
    runtimeBind = Globalize._runtimeBind,
    validateCldr = Globalize._validateCldr,
    validateDefaultLocale = Globalize._validateDefaultLocale,
    validateParameterPresence = Globalize._validateParameterPresence,
    validateParameterTypeString = Globalize._validateParameterTypeString,
    validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
  const Cardinals = require("make-plural/cardinals");
  var relativeTimeFormat = function (value, numberFormatter, properties, cldr) {
    var relativeTime,
      message = properties["relative-type-" + value];
    if (message) {
      return message;
    }
    relativeTime = value <= 0 ? properties["relativeTime-type-past"] : properties["relativeTime-type-future"];
    value = Math.abs(value);
    const locale = cldr.locale.replace(/-.*/, "");
    const val = Cardinals[locale](value);
    message = relativeTime["relativeTimePattern-count-" + val];
    return formatMessage(message, [numberFormatter(value)]);
  };
  var relativeTimeFormatterFn = function (numberFormatter, properties, cldr) {
    return function relativeTimeFormatter(value) {
      validateParameterPresence(value, "value");
      validateParameterTypeNumber(value, "value");
      return relativeTimeFormat(value, numberFormatter, properties, cldr);
    };
  };
  var relativeTimeProperties = function (unit, cldr, options) {
    var form = options.form,
      raw,
      properties,
      key,
      match;
    if (form) {
      unit = unit + "-" + form;
    }
    raw = cldr.main(["dates", "fields", unit]);
    properties = {
      "relativeTime-type-future": raw["relativeTime-type-future"],
      "relativeTime-type-past": raw["relativeTime-type-past"]
    };
    for (key in raw) {
      if (Object.prototype.hasOwnProperty.call(raw, key)) {
        match = /relative-type-(-?[0-9]+)/.exec(key);
        if (match) {
          properties[key] = raw[key];
        }
      }
    }
    return properties;
  };
  Globalize.formatRelativeTime = Globalize.prototype.formatRelativeTime = function (value, unit, options) {
    validateParameterPresence(value, "value");
    validateParameterTypeNumber(value, "value");
    return this.relativeTimeFormatter(unit, options)(value);
  };
  Globalize.relativeTimeFormatter = Globalize.prototype.relativeTimeFormatter = function (unit, options) {
    var args, cldr, numberFormatter, properties, returnFn;
    validateParameterPresence(unit, "unit");
    validateParameterTypeString(unit, "unit");
    cldr = this.cldr;
    options = options || {};
    args = [unit, options];
    validateDefaultLocale(cldr);
    cldr.on("get", validateCldr);
    try {
      properties = relativeTimeProperties(unit, cldr, options);
    } finally {
      cldr.off("get", validateCldr);
    }
    numberFormatter = this.numberFormatter(options);
    returnFn = relativeTimeFormatterFn(numberFormatter, properties, cldr);
    runtimeBind(args, cldr, returnFn, [numberFormatter, properties]);
    return returnFn;
  };
  return Globalize;
});
